export const FindUseLocationText: Record<string, string> = {
    datasheet: '数据表',
    field: '字段',
    page: '页面',
    workflow: '工作流节点',
    block: '组件'
}
